import { __assign } from "tslib";
import { textColor } from '../marks/color';
export var status = function (node) {
    var text = "*[ " + node.attrs.text.toUpperCase() + " ]*";
    var newAttrs = __assign({}, node.attrs);
    if (node.attrs.color === 'neutral') {
        newAttrs.color = 'grey';
    }
    return textColor(text, newAttrs);
};
//# sourceMappingURL=status.js.map